export default "__VITE_ASSET__DdWYj90V__"